import { render } from "./ForPartners.vue?vue&type=template&id=72158626"
const script = {}
script.render = render

export default script